export default __webpack_public_path__ + "static/media/emergency-tick.97cc1963.svg";